export const DEFAULT_STYLING = {
  animation: null,
  rotation: null,
  size: null,
  colorPrimary: '#1E3050FF',
  colorSecondary: '#1E305066',
  opacityPrimary: 1.0,
  opacitySecondary: 0.4,
  previewMode: 'day'
}
